import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getRulesets = async (queries = '') => {
  const { data } = await SigliveServiceV1({ method: 'GET', url: `/schedule/ruleset?${queries}` });

  return data?.data;
};

export default getRulesets;
